import React from "react"
import { Col, Container, Row } from "reactstrap"
import { useRosterSelectors, useRosterState } from "web/redux/slices/roster-slice"
import { PlayerList } from './PlayerList'
import { sortPlayers } from 'web/utils/sort-utils'

type EditRosterContainerProps = {

}

export const EditRosterContainer: React.FC<EditRosterContainerProps> = () => {

    const rosterSelectors = useRosterSelectors()
    const rosterState = useRosterState()

    const sortedPlayers = [...rosterState.players].sort(sortPlayers)
    const playersByRole = rosterSelectors.getPlayersByRole(sortedPlayers)

    return (
        <div
            className="d-flex flex-column flex-grow-1"
            style={{
                // maxWidth: "350px",
            }}
        >
            <h4 className="mb-3">{"Manage roster"}</h4>

            <Container fluid style={{
                padding: "0px",
            }}>

                <Row>
                    <Col xl={3} lg={12} className="mb-3 mb-xl-0">
                        <h5> {"Tanks"} </h5>
                        <PlayerList players={playersByRole.tanks} />
                    </Col>
                    <Col xl={3} lg={12} className="mb-3 mb-xl-0">
                        <h5> {"Healers"} </h5>
                        <PlayerList players={playersByRole.healers} />
                    </Col>
                    <Col xl={3} lg={12} className="mb-3 mb-xl-0">
                        <h5> {"Melee"} </h5>
                        <PlayerList players={playersByRole.melee} />
                    </Col>
                    <Col xl={3} lg={12} className="">
                        <h5> {"Ranged"} </h5>
                        <PlayerList players={playersByRole.ranged} />
                    </Col>
                </Row>

            </Container>

        </div>
    )
}
